import { render, staticRenderFns } from "./ReadCounselingQuestions.vue?vue&type=template&id=03f8219b&scoped=true&"
import script from "./ReadCounselingQuestions.vue?vue&type=script&lang=ts&"
export * from "./ReadCounselingQuestions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f8219b",
  null
  
)

export default component.exports